import React, { useEffect, useState } from "react";
import { getAllClient } from "../../../Services/Superadmin/Superadmin";
import { TotalcountLicence } from "../../../Services/Admin/Addmin";
import { getUserFromToken } from "../../../Utils/TokenVerify";

const Profile = () => {
  const TokenData = getUserFromToken();
  const user_id = TokenData?.user_id;

  const [client, setClient] = useState({});
  const [checkLicence, setCheckLicence] = useState({});
  const [loading, setLoading] = useState(true);



  const getallclient = async () => {
    try {
      const data = { userid: user_id };
      const response = await getAllClient(data);
      if (response.status) {
        setClient(response.data || {});
      }
    } catch (error) {
      console.error(error);
    }
  };




  const gettotallicence = async () => {
    try {
      const data = { userid: user_id };
      const response = await TotalcountLicence(data);
      if (response.status) {
        setCheckLicence(response.data || {});
      }
    } catch (error) {
      console.error(error);
    }
  };




  useEffect(() => {
    const fetchData = async () => {
      await Promise.all([getallclient(), gettotallicence()]);
      setLoading(false);
    };
    fetchData();
  }, []);



  const userName = client?.UserName || "User";
  const phone = client?.PhoneNo || "Not available";

  return (
    <div className="container-fluid">
      <div className="card transaction-table custom-bg">
        <div className="row justify-content-center ">
          <div className="col-xl-12 col-lg-12 col-md-12">

            {/* HEADER */}
            <div className="card-header border-0 flex-wrap  ">
              <div>
                <h3 className="fw-semibold mb-0">My Profile</h3>
                <p className="text-muted mb-0">
                  View your basic information and licence summary.
                </p>
              </div>
            </div>

            {/* MAIN CARD */}
            <div className="card shadow-sm border-0 rounded-4">
              {loading ? (
                <div className="card-body py-5 d-flex justify-content-center align-items-center">
                  <div className="text-center">
                    <div
                      className="spinner-border"
                      role="status"
                      aria-hidden="true"
                    ></div>
                    <div className="mt-2 text-muted small">Loading profile...</div>
                  </div>
                </div>
              ) : (
                <>
                  {/* PROFILE HEADER */}
                  <div className="card-body border-bottom">
                    <div className="d-flex align-items-center">
                      <div className="me-3 position-relative">
                        <img
                          src="/assets/images/man.png"
                          alt="Profile"
                          className="rounded-circle border"
                          style={{ width: 80, height: 80, objectFit: "cover" }}
                        />
                        <span
                          className="position-absolute bottom-0 end-0 bg-success rounded-circle border border-white"
                          style={{ width: 14, height: 14 }}
                        ></span>
                      </div>
                      <div className="flex-grow-1">
                        <h5 className="mb-1 fw-semibold">{userName}</h5>
                        <p className="mb-1 text-muted small">
                          User ID: <span className="fw-medium">{user_id}</span>
                        </p>
                        <span className="badge bg-primary-subtle text-primary border border-primary-subtle">
                          Active User
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* DETAILS + LICENCE INFO */}
                  <div className="card-body">
                    <div className="row g-3">
                      {/* Basic Details */}
                      <div className="col-md-6">
                        <div className="border rounded-3 h-100">
                          <div className="px-3 pt-3 pb-2 border-bottom d-flex justify-content-between align-items-center">
                            <h6 className="mb-0 fw-semibold">Basic Details</h6>
                          </div>
                          <ul className="list-group list-group-flush">
                            <li className="list-group-item d-flex justify-content-between align-items-center">
                              <div>
                                <div className="small text-muted">Name</div>
                                <div className="fw-medium">{userName}</div>
                              </div>
                            </li>
                            <li className="list-group-item d-flex justify-content-between align-items-center">
                              <div>
                                <div className="small text-muted">
                                  Phone Number
                                </div>
                                <div className="fw-medium">{phone}</div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>

                      {/* Licence Summary */}
                      <div className="col-md-6">
                        <div className="border rounded-3 h-100">
                          <div className="px-3 pt-3 pb-2 border-bottom d-flex justify-content-between align-items-center">
                            <h6 className="mb-0 fw-semibold">Licence Summary</h6>
                          </div>
                          <div className="p-3">
                            {/* Adjust these fields according to your API response shape */}
                            <div className="d-flex justify-content-between mb-2">
                              <span className="text-muted small">
                                Total Licences
                              </span>
                              <span className="fw-semibold">
                                {checkLicence?.total || checkLicence?.TotalCount || 0}
                              </span>
                            </div>
                            {checkLicence?.active !== undefined && (
                              <div className="d-flex justify-content-between mb-2">
                                <span className="text-muted small">
                                  Active Licences
                                </span>
                                <span className="fw-semibold">
                                  {checkLicence.active}
                                </span>
                              </div>
                            )}
                            {checkLicence?.expired !== undefined && (
                              <div className="d-flex justify-content-between">
                                <span className="text-muted small">
                                  Expired Licences
                                </span>
                                <span className="fw-semibold text-danger">
                                  {checkLicence.expired}
                                </span>
                              </div>
                            )}
                            {!checkLicence ||
                              (Object.keys(checkLicence).length === 0 && (
                                <div className="text-muted small">
                                  No licence data available.
                                </div>
                              ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* FOOTER
                <div className="card-footer bg-white border-0 text-end">
                  <button
                    type="button"
                    className="btn btn-outline-primary "
                  >
                    Edit Profile
                  </button>
                </div> */}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
